module.exports = __webpack_public_path__ + "static/media/stop.f74ba92b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stop.svg
// module id = 904
// module chunks = 0